import EnumsContext from "../../../../context/enums-context";
import useApi from "../../../../Utils/BackendClient";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useIsMobile } from "../../../../Utils/ResizeUtils";
import { useLocation, useNavigate } from "react-router-dom";
import { UserPermissionContext } from "../../../../context/UserPermissionProvider";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";

import commonStyle from "../../CommonStyles.module.css";
import { useEnumLabel } from "../../../../Utils/Utils";

const Clients = () => {

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const permCtx = useContext(UserPermissionContext)
    const toast = useRef(null);

    const { deleteCagent, fetchClients } = useApi();

    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [reloadData, setReloadData] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
    });

    const enumTypes = useMemo(() => ["cagent_types"], []);

    useGetEnums(enumTypes);

    const getCagentTypesLabel = useEnumLabel(ctx.enums.cagent_types.data);

    useEffect(() => {
        
        const fetchData = async () => {

            let state = lazyState;

            if(location.state?.pageState){

                state = location.state?.pageState;
                setlazyState(location.state?.pageState);

                location.state.pageState = null;

                navigate(location.pathname, { replace: true, state: location.state });
            }

            const response = await fetchClients(state);

            if (response.status === 200) {
                setTotalRecords(response.data.count);
                setClients(response.data.results);
            }
            else{
                setTotalRecords(0);
                setClients([]);
                if(response.status === 403){
                    toast.current.show({ severity: "error", summary: "Помилка завантаження списку клієнтів", detail: "Користувач не має права переглядати сторінку", life: 3000 });
                }
                else if(response.status === 401){
                    toast.current.show({ severity: "error", summary: "Помилка завантаження списку клієнтів", detail: "Авторизуйтесь повторно на сайт", life: 3000 });
                }
                else{
                    toast.current.show({ severity: "error", summary: "Помилка завантаження списку клієнтів", detail: "Помилка сервера " + response.status, life: 3000 });
                }
            }

            setLoading(false);
        }

        fetchData();

    }, [fetchClients, lazyState, location, navigate, reloadData]);

    useEffect(() => {

         if(location.state?.toast){
            toast.current.show(location.state.toast);

            location.state.toast = null;
            navigate(location.pathname, { replace: true, state: location.state});
        }

    }, [location, navigate]);

    const DeleteButtonHandler = async (rowData) => {

        const response = await deleteCagent(rowData.id);

        if (response.status !== 204) {
            toast.current.show({ severity: "error", summary: "Помилка видалення", detail: "Помилка сервера " + response.status, life: 3000 });
        }
        else {
            toast.current.show({ severity: "success", summary: 'Видалення', detail: 'Клієнта успішно видалено', life: 3000 });
        }

        setReloadData(!reloadData);
    }

    const NewCounterAgentButtonHandler = () => {
        navigate('/clients/newcounteragent', { state: { isClient: true, pageState: lazyState } });
    }

    const EditClientButtonHandler = rowData => {
        const route = '/clients/editcounteragent/' + rowData.id;
        navigate(route, { state: { isClient: true, id: rowData.id, pageState: lazyState } });
    }

    const onPage = (event) => {
        event.page = event.page + 1;
        setlazyState(event);
    };

    const confirmDelete = (event, rowData) => {
        confirmPopup({
            group: 'headless',
            target: event.currentTarget,
            message: 'Підтвердіть видалення клієнта',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => {DeleteButtonHandler(rowData)}
        });
    }

    const toolbarRightTemplate = () => {
        return (<div className="flex flex-wrap gap-2">
            {permCtx.permissions?.includes("cagents.add_cagent_client") && <Button label="Додати клієнта" severity="success" className={commonStyle.addButton} onClick={NewCounterAgentButtonHandler} />}
        </div>)
    }

    const mobileRowBody = rowData => {
        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-12">
                        <div className="flex-column">
                            <div className="font-bold"><i className={`pi ${ rowData.type === "INDIVIDUAL" ? "pi-user" : "pi-building"}`}/> {rowData.name}</div>
                            <div><i className="pi pi-clock"/> {rowData.phone === "" ? "Телефон не вказано" : rowData.phone}</div>
                            <div><i className="pi pi-at"/> {rowData.email === "" ? "Email не вказано" : rowData.email}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {actionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (<div className="flex flex-wrap gap-2">
            {permCtx.permissions?.includes("cagents.delete_cagent_client") && <Button
                icon="pi pi-trash"
                className={`p-button-rounded p-button-danger ${rowData.can_be_deleted ? commonStyle.deleteButton : commonStyle.closeButton}`}
                tooltip={!isMobile ? (rowData.can_be_deleted ? "Видалити клієнта" : "Неможливо видалити") : null}
                tooltipOptions={{ showOnDisabled: true, position:"top" }}
                disabled={!rowData.can_be_deleted}
                onClick={(event) => confirmDelete(event, rowData)}
            />}
            {permCtx.permissions?.includes("cagents.view_cagent_client") && <Button
                icon="pi pi-pencil"
                className={`p-button-rounded p-button-info ${commonStyle.editButton}`}
                tooltip="Редагувати клієнта"
                onClick={() => EditClientButtonHandler(rowData)}
            />}
        </div>
        );
    };

    return (<>
        <Toast ref={toast} />
        <Toolbar className="mb-4" end={toolbarRightTemplate}></Toolbar>
        <div className='grid'>
            <div className='col-12 justify-content-center'>
                {!isMobile &&<DataTable value={clients} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage}
                    first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} tableStyle={{ minWidth: '60rem' }} >
                    <Column field="name" header="Назва клієнта" />
                    <Column field="type" header="Тип" body={rowData => getCagentTypesLabel(rowData.type)} />
                    <Column field="phone" header="Телефон" />
                    <Column field="email" header="Email" />
                    <Column field="created_by" header="Користувач" />
                    <Column field="action" body={actionBodyTemplate} />
                </DataTable>}
                {isMobile && <DataTable value={clients} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} 
                    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" dataKey="id" emptyMessage="Клієнтів не знайдено" >
                    <Column field="id" headerStyle={{ display: 'none' }} body={mobileRowBody} />
                </DataTable>}
            </div>
            <ConfirmPopup group="headless" />
        </div>
    </>)
}

export default Clients;